import script from "./ImagePopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImagePopup.vue?vue&type=script&lang=ts&setup=true"

import "./ImagePopup.vue?vue&type=style&index=0&id=5fb3d233&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb3d233"]])

export default __exports__